export default "__VITE_ASSET__Brzpj6Sm__"